import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src592612800/src/mtalkz.com/app/blog/CategoryChangeHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogCard"] */ "/codebuild/output/src592612800/src/mtalkz.com/components/blog/blog-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogPostRows"] */ "/codebuild/output/src592612800/src/mtalkz.com/components/blog/blog-post-rows.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogSidebar"] */ "/codebuild/output/src592612800/src/mtalkz.com/components/blog/blog-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/codebuild/output/src592612800/src/mtalkz.com/components/ui/pagination.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/node_modules/react-wrap-balancer/dist/index.mjs");
